import { Row, Col, Radio, Modal, Form, Input } from "antd";
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/style.css'
import React, { useState, useEffect, useRef } from "react";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";

const From = ({ path, sectionName, show, hide, data, refresh }) => {

  const [form]                          =   Form.useForm();
  const { request }                     =   useRequest();
  const [loading, setLoading]           =   useState(false);
  const [mobileNumber, setMobileNumber] =   useState({ mobile: '', country_code: '' });

  const handleChange = (value, data) => {
    var country_code = data.dialCode;
    setMobileNumber({ country_code: country_code, mobile: value.slice(data.dialCode.length) });
  }

  useEffect(() => {
    if (!data) return;
    form.setFieldsValue({ ...data });
    setMobileNumber({ mobile: data.mobile_number, country_code: data.country_code })
  }, [data])

  const onCreate = (values) => {
    if (!mobileNumber.mobile) return ShowToast('Please enter mobile number', Severty.ERROR)
    
      if (((mobileNumber.mobile).length < 8 || (mobileNumber.mobile).length > 12)) {
      return ShowToast('Mobile number should be between 8 to 12 digits', Severty.ERROR);
    }

    const payload = {
      ...values,
      otp_verification: data && data.is_otp_verify ? data.is_otp_verify : false,
      mobile_number : mobileNumber.mobile,
      country_code  : mobileNumber.country_code,
    }
    
    setLoading(true);
    request({
      url: `${data ? path + "/" + data._id : path}`,
      method: 'POST',
      data: payload,
      onSuccess: (data) => {
        setLoading(false);
        if (data.status) {
          ShowToast(data.message, Severty.SUCCESS);
          hide();
          refresh();
        } else {
          ShowToast(data.message, Severty.ERROR);
        }
      },
      onError: (error) => {
        ShowToast(error.response.data.message, Severty.ERROR);
        setLoading(false);
      },
    })
  };

  return (
    <Modal
      width={1000}
      open={show}
      title={`${data ? 'Update ' + sectionName : 'Create a New ' + sectionName}`}
      okText="Ok"
      onCancel={hide}
      okButtonProps={{
        form: 'create',
        htmlType: 'submit',
        loading: loading,
      }}
    >
      <Form id="create" form={form} onFinish={onCreate} layout="vertical">
        <Row gutter={[16, 16]}>
          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="First Name"
              name="first_name"
              normalize={value => value.trimStart()}
              rules={[
                { required: true, message: "Please Enter the first name!" },
                { max: 255, message: "First name should not contain more then 255 characters!" },
                { min: 2, message: "First name should contain at least 2 characters!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Enter First Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Middle Name"
              name="middle_name"
              normalize={value => value.trimStart()}
              rules={[
                { max: 255, message: "Middle name should not contain more then 255 characters!" },
                { min: 2, message: "Middle name should contain at least 2 characters!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Middle Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Last Name"
              name="last_name"
              normalize={value => value.trimStart()}
              rules={[
                { required: true, message: "Please Enter the last name!" },
                { max: 255, message: "Last name should not contain more then 255 characters!" },
                { min: 2, message: "Last name should contain at least 2 characters!" },
                { pattern: new RegExp(/^[a-zA-Z ]*$/), message: "Only Alphabetic Characters Allowed!" }
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Last Name" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8}>
            <Form.Item className="mb-0"
              label="Email Address (Optional)"
              name="email"
              rules={[
                { type: 'email', message: 'The email is not a valid email!' },
                { max: 50, message: "Email should not contain more then 50 characters!" },
                { min: 5, message: "Email should contain at least 5 characters!" },
                {
                  pattern: new RegExp(/^([a-zA-Z0-9._%-]*[a-zA-Z]+[a-zA-Z0-9._%-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/),
                  message: "Enter valid email!"
                }
              ]}
            >
              <Input autoComplete="off" placeholder="Enter Email Address" />
            </Form.Item>
          </Col>

          <Col span={24} xs={12} sm={12} md={8} className="flagMobileNumber">
            <Form.Item className="mb-0" required={true} 
            label="Mobile Number">
              <PhoneInput inputProps={{
                name: "mobile",
                required: true,
                autoFocus: false,
                placeholder: "Enter Mobile Number"
              }}
                isValid={(value, country) => {
                  if (value.match(/1234/)) {
                    return 'Invalid value: ' + value + ', ' + country.name;
                  } else if (value.match(/1234/)) {
                    return 'Invalid value: ' + value + ', ' + country.name;
                  } else {
                    return true;
                  }
                }}
                country={"in"} value={mobileNumber ? ((mobileNumber.country_code ? mobileNumber.country_code : "+91") + (mobileNumber.mobile ? mobileNumber.mobile : null)) : '+91'} onChange={handleChange} />
            </Form.Item>
          </Col>

        </Row>
      </Form>
    </Modal>
  )
};

export default From;